<div *ngIf="bot" class="row">
  <div class="col-md-12">
    <form class="form-validation container-fluid">
      <!-- Only on new -->
      <div class="row">
        <!-- Edit & new from here -->
        <div class="col-12">
          <div class="row mt-3 fields-group container-breakpoints">
            <div class="col-container-12 col-container-sm-8">
              <div class="list-title d-flex w-100 pr-3">
                <span class="field-required">
                  {{ 'roles.name' | translate }}
                </span>
              </div>
              <form *ngIf="!bot.id" class="form-controller">
                <input class="form-control" type="text" name="roleName" [(ngModel)]="bot.name" #name="ngModel"
                  [rangeLength]="[2, 256]" placeholder="{{ 'Type a bot name' | translate }}"
                  (input)="nameChanged($event.target.value)" (focus)="startEdit($event)"
                  (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()" required />
                <p class="validation-error" *ngIf="name?.errors?.required && (name?.dirty && name?.touched)">
                  {{ 'form.validate.required' | translate }}
                </p>
                <p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.minLenght' | translate }} 2!
                </p>
                <p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.maxLenght' | translate }} 256!
                </p>
              </form>
              <form *ngIf="bot.id" class="form-controller">
                <input class="form-control" type="text" name="roleName" [(ngModel)]="bot.name" #name="ngModel"
                  [rangeLength]="[2, 256]" placeholder="{{ 'Type a bot name' | translate }}" (focus)="startEdit($event)"
                  (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()" required />
                <p class="validation-error" *ngIf="name?.errors?.required && (name?.dirty && name?.touched)">
                  {{ 'form.validate.required' | translate }}
                </p>
                <p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.minLenght' | translate }} 2!
                </p>
                <p class="validation-error" *ngIf="name?.errors?.rangeLength && (name?.dirty && name?.touched)">
                  {{ 'form.validate.maxLenght' | translate }} 256!
                </p>
              </form>
            </div>
            <div class="col-container-12 col-container-sm-4">
              <div class="list-title mr-3 mr-md-0">
                <span class="field-required">
                  {{ 'roles.short_name' | translate }}
                </span>
              </div>
              <form class="form-controller">
                <input required class="form-control" type="text" name="roleShortName" [(ngModel)]="bot.shortName"
                  [rangeLength]="[2, 20]" #sname="ngModel" (focus)="startEdit($event)"
                  (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()" />
              </form>
              <p class="validation-error" *ngIf="sname?.errors?.required && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.required' | translate }}
              </p>
              <p class="validation-error" *ngIf="sname?.errors?.rangeLength && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.minLenght' | translate }} 2!
              </p>
              <p class="validation-error" *ngIf="sname?.errors?.rangeLength && (sname?.dirty && sname?.touched)">
                {{ 'form.validate.maxLenght' | translate }} 20!
              </p>
            </div>
          </div>

          <div class="row mb-4 fields-group container-breakpoints">

            <div class="col-container-12 col-container-sm-6 col-container-md-4">
              <label class="list-title"><span class="field-required">{{ 'bots.typeSelector' | translate
                  }}</span></label>
              <select *ngIf="bot?.id" name="botType" class="form-control" [(ngModel)]="bot.botType" disabled>
                <option disabled selected>{{ 'general.select' | translate }}</option>
                <option value="data">{{ 'bots.dataBot' | translate }}</option>
                <option value="document">{{ 'bots.documentBot' | translate }}</option>
                <option value="internal">{{ 'bots.internalBot' | translate }}</option>
                <option value="message">{{ 'bots.messageBot' | translate }}</option>
                <option value="link">{{ 'Link Bot' | translate }}</option>
              </select>
              <select *ngIf="!bot?.id" name="botType" class="form-control" [(ngModel)]="bot.botType"
                (change)="submitEditOnFocus($event, false);loadDocuments();$event.stopPropagation()">
                <option disabled selected>{{ 'general.select' | translate }}</option>
                <option value="data">{{ 'bots.dataBot' | translate }}</option>
                <option value="document">{{ 'bots.documentBot' | translate }}</option>
                <option value="internal">{{ 'bots.internalBot' | translate }}</option>
                <option value="message">{{ 'bots.messageBot' | translate }}</option>
                <option value="link">{{ 'Link Bot' | translate }}</option>
              </select>
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4" *ngIf="bot.botType === 'data'">
              <label class="list-title">{{ 'bots.categorySelector' | translate }}</label>
              <select name="category" class="form-control" [(ngModel)]="bot.category"
                (change)="bot.botServiceId = '';submitEditOnFocus($event, false);$event.stopPropagation()">
                <option disabled selected>{{ 'general.select' | translate }}</option>
                <option value="create">{{ 'bots.categoryCreate' | translate }}</option>
                <option value="exist">{{ 'bots.categoryExist' | translate }}</option>
                <option value="list">{{ 'bots.categoryList' | translate }}</option>
                <option value="read">{{ 'bots.categoryRead' | translate }}</option>
                <option value="log">{{ 'bots.categoryLog' | translate }}</option>
                <option value="update">{{ 'bots.categoryUpdate' | translate }}</option>
                <option value="listener">{{ 'bots.categoryListener' | translate }}</option>
                <option value="other">{{ 'bots.categoryOther' | translate }}</option>
              </select>
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4" *ngIf="bot.botType === 'document'">
              <label class="list-title">{{ 'bots.categorySelector' | translate }}</label>
              <select name="category" class="form-control" [(ngModel)]="bot.category"
                (change)="submitEditOnFocus($event, true);$event.stopPropagation()">
                <option disabled selected>{{ 'general.select' | translate }}</option>
                <option value="document_generate_and_display">{{ 'bots.document_generate_and_display' | translate }}
                </option>
                <option value="document_generate_and_upload">{{ 'bots.document_generate_and_upload' | translate }}
                </option>
                <option value="document_generate_upload_display">{{ 'bots.document_generate_upload_display' | translate
                  }}</option>
                <option value="document_upload">{{ 'bots.document_upload' | translate }}</option>
              </select>
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4">
              <label class="list-title">{{ 'roles.section_description' | translate }}</label>
              <textarea name="description" [(ngModel)]="bot.description" class="form-control oneline-textarea"
                (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()"
                rows=1 #desc="ngModel" [rangeLength]="[0, 256]"></textarea>
              <p class="validation-error" *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }}
                256!</p>
            </div>

          </div>

          <div class="row mb-4 fields-group container-breakpoints" *ngIf="bot.botType === 'link'">
            <div class="col-container-12 col-container-sm-6 col-container-md-4">
              <label class="ui-checkbox input-label mt-4">
                <input class="form-control" name="isEregistrationService" type="checkbox"
                  [(ngModel)]="bot.isEregistrationService" (change)="onEregistrationServiceChange()">
                <span>{{ 'Is e-Registration Service' | translate }}</span>
              </label>
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4" *ngIf="!bot.isEregistrationService">
              <label class="list-title">{{ 'Redirect URL' | translate }}</label>
              <input type="text" class="form-control" name="redirectUrl" [(ngModel)]="bot.redirectUrl"
                (focus)="startEdit($event)" (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()">
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4" *ngIf="bot.isEregistrationService">
              <label class="list-title">{{ 'Service' | translate }}</label>
              <ng-select [items]="services" bindLabel="name" bindValue="id" [(ngModel)]="selectedServiceId"
                name="serviceSelect" [clearable]="true" placeholder="{{ 'Select Service' | translate }}">
              </ng-select>
            </div>

            <div class="col-container-12 col-container-sm-6 col-container-md-4">
              <label class="ui-checkbox input-label mt-4">
                <input class="form-control" name="externalTarget" type="checkbox" [(ngModel)]="bot.externalTarget">
                <span>{{ 'Open in new tab' | translate }}</span>
              </label>
            </div>
          </div>

          <div class="row fields-group py-2" *ngIf="bot.botType !== 'message'">
            <div class="col">
              <label class="ui-checkbox input-label">
                <input class="form-control" name="allowAnonymousAuthentication" type="checkbox"
                  value="{{bot.allowAnonymousAuthentication}}" [(ngModel)]="bot.allowAnonymousAuthentication"
                  (change)="autoSave()">
                <span>{{ 'bot.allow_anonymous_authentication' | translate }}</span>
              </label>
            </div>
          </div>

          <div class="row mb-4 fields-group container-breakpoints" *ngIf="bot.botType === 'document'">
            <div class="col-container-12 col-container-sm-6 mb-0 mb-md-0">
              <label class="list-title">{{ 'bots.certificateSelector' | translate }}</label>
              <!--<select name="selectedPrint" class="form-control" [(ngModel)]="bot.selectedPrint"
                          (change)="submitEditOnFocus($event, false);$event.stopPropagation()">
                          <option disabled selected>{{ 'general.select' | translate }}</option>
                          <option *ngFor="let item of printDocuments" value="{{item.id}}">{{ item.name }}</option>
                        </select>-->
              <search-select name="selectedPrint" [selected]="bot.selectedPrint" [items]="printDocuments"
                [placeholder]="'Search' | translate" [prop]="'id'" (change)="updateDoc($event);">
              </search-select>
            </div>
            <div class="col-container-12 col-container-sm-6 pr-md-0 mb-3" *ngIf="bot.category === 'document_upload'">
              <label class="list-title">{{ 'File upload component' | translate }}</label>
              <search-select name="fileUploadComponent" [selected]="bot.selectedFileUploadComponentKey"
                [items]="fileUploadComponents" [placeholder]="'Search' | translate" [prop]="'key'"
                (change)="updateFuc($event);">
              </search-select>
            </div>
          </div>
          <div class="row mb-4 fields-group no-filter container-breakpoints" *ngIf="bot.botType === 'message'">
            <div class="col">
              <div class="row mb-4">
                <div class="col-container-12  col-container-sm-8 col-container-md-8">
                  <label class="list-title mb-3">
                    <span class="field-required">{{ 'Send by' | translate }}</span>
                  </label>
                  <br>
                  <div class="btn-group-primary-light btn-group-toggles d-inline-flex">
                    <button *ngFor="let option of availableChannels" (click)="updateChannel(option.id)"
                      class="btn-group-toggle {{option.id === bot.selectedChannel ? 'active' : ''}}"
                      [ngClass]="{'disabled': option.disabled}">
                      <i *ngIf="option.icon" class="far fa-{{option.icon}} mr-1"></i>{{ option.name | translate }}
                    </button>
                  </div>
                </div>
                <div class="col-container-12  col-container-sm-4 col-container-md-4">
                  <label class="list-title">
                    <span class="">&nbsp;</span>
                  </label>
                  <br>
                  <toggle-switch [containerClass]="'toggle-switch-field'"
                    [tooltip]="'Send a notification alongside message when enabled' | translate" placement="top"
                    [toggled]="bot.sendAlert" (toggledChange)="updateNotificationAlso($event)"
                    [label]="'Notification also' | translate"></toggle-switch>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-container-12 col-container-sm-10 mb-0 mb-md-0">
                  <label class="list-title">
                    <span class="field-required">{{ 'Select a receiver' | translate }}</span>
                  </label>
                  <br>
                  <i class="fad fa-spin fa-spinner-third" *ngIf="loadingReceivers"></i>
                  <search-select *ngIf="receivers.length && !loadingReceivers" name="selectedReceiver"
                    [selected]="bot.selectedReceiver" [items]="receivers" [placeholder]="'Search' | translate"
                    [prop]="'id'" (change)="updateReceiver($event);">
                  </search-select>
                </div>
              </div>
              <div class="row">
                <div class="col-container-12 col-container-sm-10 mb-0 mb-md-0">
                  <label class="list-title">
                    <span class="field-required">{{ 'Message' | translate }}</span>
                  </label>
                  <div class="single-item d-flex {{message ? 'filled' : ''}}">
                    <span *ngIf="!message" (click)="openMessagesList()">{{'No message selected' | translate}}</span>
                    <span class="mr-auto" *ngIf="message" (click)="openMessagesList()">
                      <i class="far fa-{{getMessageIcon(message)}} mr-1"
                        [ngClass]="{'btn-circle-icon btn-circle-small btn-danger': (message.channel || 'EMAIL') !== bot.selectedChannel}"
                        [tooltip]="(message.channel || 'EMAIL') !== bot.selectedChannel ? ('The message channel differs from the selected send by channel' | translate) : false"></i>
                      {{message.subject}}
                    </span>
                    <i *ngIf="message" (click)="openMessageEdit()"
                      class="fal fa-pencil btn-xs btn-outline-dark btn-icon item-remove ml-2"></i>
                    <confirmation-popover *ngIf="message" class="ml-2"
                      className="fas fa-times btn-xs btn-bordered btn-danger btn-icon nglist-item-action"
                      (onConfirmed)="clearMessage()"></confirmation-popover>
                  </div>
                </div>
                <div class="col-container-12 col-container-sm-2 mb-0 mb-md-0">
                  <label class="list-title mb-3">
                    <span class="">&nbsp;</span>
                  </label>
                  <br>
                  <span (click)="openMessagesList()" class="btn btn-primary">{{'Select' | translate}}</span>
                </div>
              </div>
            </div>

          </div>

          <!--
                    <div class="row fields-group container-breakpoints">
                      <div class="col-container-12 col-container-sm-6 mb-0 mb-md-0">
                          <label class="list-title">{{ 'bots.success_message' | translate }}</label>
                          <textarea name="success_message"
                                    [(ngModel)]="bot.botSuccessMessage"
                                    class="form-control oneline-textarea"
                                    (focus)="startEdit($event)"
                                    (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()"
                                    rows=1
                                    [rangeLength]="[0, 256]"></textarea>
                          <p class="validation-error"
                             *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                      </div>
                      <div class="col-container-12 col-container-sm-6 mb-0 mb-md-0">
                          <label class="list-title">{{ 'bots.fail_message' | translate }}</label>
                          <textarea name="fail_message"
                                    [(ngModel)]="bot.botFailMessage"
                                    class="form-control oneline-textarea"
                                    (focus)="startEdit($event)"
                                    (focusout)="submitEditOnFocus($event, false);$event.stopPropagation()"
                                    rows=1
                                    [rangeLength]="[0, 256]"></textarea>
                          <p class="validation-error"
                             *ngIf="desc.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 256!</p>
                      </div>
                    </div>
                    -->

        </div>
      </div>
    </form>
  </div>
</div>

<status-message-list *ngIf="showMessagesList && bot.botType === 'message'" (editCancel)="closeMessagesList();"
  [messageData]="messageData" [messageToEdit]="messageToEdit" (selectItem)="addMessage($event)"
  class="row px-3 role-status-messages-list">
</status-message-list>